module.exports = __webpack_public_path__ + "img/ai-companion2.00f76f05.svg";